import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PageComponent } from 'app/components/page/PageComponent';

@Component({
  templateUrl: './static-error-page.component.html',
  styleUrls: ['./static-error-page.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StaticErrorPageComponent extends PageComponent {}
